import React, { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { useGetPensionDialogueData } from '../../../../api/pension-robot/useGetPensionDialogueData';
import { RobotEnvironmentContext } from '../../../../contexts/general/RobotEnvironmentContext';
import { LoadingStateWrapper } from '../../../general/LoadingStateWrapper';

export type PensionProgressSaverData = {
    contactDetails: {
        name: string,
        email: string,
        phone: string
    },
    mayCallChecked: boolean,
    mayUseData: boolean,
    setRetrievedProgressSucceeded: boolean,
    autoSaveMyBND: boolean,
    dataIsSavedAtLeastOnce: boolean,
};

type PensionProgressSaverContextType = {
    pensionProgressSaverData: PensionProgressSaverData,
    setPensionProgressSaverData: Dispatch<SetStateAction<PensionProgressSaverData>> | undefined,
};

export const PensionProgressSaverContext = createContext<PensionProgressSaverContextType>({
    pensionProgressSaverData : {
        contactDetails: {
            name: '',
            email: '',
            phone: ''
        },
        mayCallChecked: false,
        mayUseData: false,
        setRetrievedProgressSucceeded: false,
        autoSaveMyBND: true,
        dataIsSavedAtLeastOnce: false,
    },
    setPensionProgressSaverData : undefined,
});

export const WithPensionProgressSaverData: React.FC<{children?: React.ReactNode}> = ({
    children
}) => {
    const { userTokenIsNew } = useContext(RobotEnvironmentContext);
    const [ dataIsFetched, setDataIsFetched ] = useState(false);
    const shouldNotFetchData = dataIsFetched || userTokenIsNew;
    const [pensionProgressSaverData, setPensionProgressSaverData] = useState<PensionProgressSaverData>({
        contactDetails: {
            name: '',
            email: '',
            phone: ''
        },
        mayCallChecked: false,
        mayUseData: false,
        setRetrievedProgressSucceeded: false,
        autoSaveMyBND: true,
        dataIsSavedAtLeastOnce: false,
    });

    const getPensionDialogueDataQuery = useGetPensionDialogueData();

    useEffect(() => {
        if (shouldNotFetchData)
            return undefined;

        getPensionDialogueDataQuery.refetch();
        setDataIsFetched(true);
    }, [shouldNotFetchData]); // eslint-disable-line react-hooks/exhaustive-deps 


    return (
        <LoadingStateWrapper 
                isLoading={getPensionDialogueDataQuery.isLoading}
                isError={false}
                isIdle={getPensionDialogueDataQuery.isIdle}
                isFetching={getPensionDialogueDataQuery.isFetching}
            >
        <PensionProgressSaverContext.Provider value={{
                pensionProgressSaverData: pensionProgressSaverData,
                setPensionProgressSaverData: setPensionProgressSaverData,
        }}>
            {children}
        </PensionProgressSaverContext.Provider>
        </LoadingStateWrapper>
    );
};